<template>
  <div class="apple-ui-section-header"><component :is="headingTag" :id="headingId || undefined" class="apple-ui-section-title">{{ title }}</component><div v-if="$slots.default" class="apple-ui-section-actions"><slot /></div></div>
</template>
<script>
export default {
  name: 'AppleSectionHeader',
  props: { title: { type: String, required: true }, headingId: { type: String, default: '' }, level: { type: Number, default: 2, validator: n => n >= 2 && n <= 6 } },
  computed: { headingTag() { return 'h' + this.level; } },
};
</script>
<style scoped>
.apple-ui-section-header { display: flex; align-items: baseline; justify-content: space-between; gap: var(--apple-ui-space-3, 12px); min-width: 0; }
.apple-ui-section-title { min-width: 0; margin: 0; font-size: var(--apple-ui-section-size, 19px); line-height: 1.25; font-weight: 700; letter-spacing: -.02em; }
.apple-ui-section-actions { display:flex; align-items:center; justify-content:flex-end; flex:0 1 auto; min-width:0; }
.apple-ui-section-actions > * { min-width:0; }
</style>
